/* Whether "public review" field should be shown */
export const shouldShowPublicReview = (values, isCreative) => (
  !isCreative && values['overall_satisfaction'] > 3
)

/*
 * Definition of all possible survey fields.
 */
export const FIELDS = [{
  name: 'timing',
  label: 'Timing',
  type: 'rating',
  textualType: 'agreement',
  section: 'user',
  shouldShow: () => true,
  description: (username, isCreative) => {
    if (isCreative) {
      return `${username} provided feedback and materials in a timely manner.`
    }
    return `${username} provided materials in a timely manner.`
  }
}, {
  name: 'communication',
  label: 'Communication',
  type: 'rating',
  textualType: 'agreement',
  section: 'user',
  shouldShow: () => true,
  description: (username) => (
    `${username}'s communication during the project was clear and thorough.`
  )
}, {
  name: 'overall_satisfaction',
  label: 'Overall Satisfaction',
  type: 'rating',
  textualType: 'satisfaction',
  section: 'user',
  shouldShow: () => true,
  description: (username) => `How satisfied were you overall in working with ${username}?`
}, {
  name: 'public_review',
  label: 'Public Review',
  type: 'text',
  initialValue: '',
  section: 'user',
  shouldShow: shouldShowPublicReview,
  description: (username) => `We're glad you are satisfied with ${username}'s work. Please leave a review for ${username} that will be displayed on their public profile.`
}, {
  name: 'additional_comments',
  label: 'Private Note for crowdspring',
  type: 'text',
  initialValue: '',
  section: 'user',
  shouldShow: () => true,
  description: (username) => `Anything you want us to know about ${username}? This is a private note just for our team.`
}, {
  name: 'using_cs',
  label: 'Using crowdspring',
  type: 'rating',
  textualType: 'agreement',
  section: 'cs',
  shouldShow: () => true,
  description: () => 'Using crowdspring to manage my project was easy.'
}, {
  name: 'quality',
  label: 'Quality',
  type: 'rating',
  textualType: 'agreement',
  section: 'cs',
  shouldShow: () => true,
  description: () => 'Overall, I received good quality designs for my project.'
}, {
  name: 'value',
  label: 'Value',
  type: 'rating',
  textualType: 'agreement',
  section: 'cs',
  shouldShow: () => true,
  description: () => 'Overall, I received good value for the money I spent.'
}, {
  name: 'recommend',
  label: 'Recommend Us',
  type: 'rating',
  textualType: 'probability',
  section: 'cs',
  shouldShow: () => true,
  description: () => 'I would recommend crowdspring to a friend.'
}, {
  name: 'cs_additional_comments',
  label: 'Additional Comments',
  type: 'text',
  initialValue: '',
  section: 'cs',
  shouldShow: () => true,
  description: () => 'Anything else you want us to know about your experience using crowdspring?'
}, {
  name: 'contact',
  label: 'Help us out?',
  type: 'checkbox',
  initialValue: true,
  section: 'cs',
  shouldShow: () => true,
  description: () => (
    'crowdspring can contact me for more information regarding my experience using the site.'
  )
}];


/*
 * Initial survey field values.
 */
export const INITIAL_VALUES = {}
FIELDS.map(s => INITIAL_VALUES[s.name] = s.initialValue)



// WEBPACK FOOTER //
// ./project/components/wrapup/survey_fields.jsx